// Dashboards hub entry for /dashboards/human-risk (see
// lib/dashboardRegistry.ts). Self-contained: no imports.
export const dashboardEntry = {
  key: 'human-risk',
  title: 'Human risk',
  description: 'See how your people respond to phishing and training, and who needs support first.',
  route: '/dashboards/human-risk',
  icon: 'users',
  // Phishing and training come from Aware; Insider adds its signals
  // when entitled. Member risk itself is part of every plan.
  apps: ['aware', 'insider'],
  // Every source behind the page is owner/admin-only.
  adminOnly: true,
} as const;
